import type { BaseIconOptions } from 'leaflet';
import { Icon } from 'leaflet';
import ClientPin from '@/Assets/svg/map-pin-client.svg';
import PlacePin from '@/Assets/svg/map-pin-place.svg';
import { image } from '@/Themes/Images';
import { STATUS_ENTREGA } from '@/Constants';
import type { StatusDelivery } from '@/Interfaces/Data';
import type { MapPosition } from './types';

export const MAP_ZOOM = 16;
export const MAP_FIT_PADDING: MapPosition = [32, 32];
export const TILE_LAYER_URL =
  'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

export const IN_DELIVERY_RUN_STATUSES: StatusDelivery[] = [
  STATUS_ENTREGA.SAIU_DA_LOJA,
  STATUS_ENTREGA.CHEGOU_NO_CLIENTE,
  STATUS_ENTREGA.ENTREGUE,
];

const dashboardIconConfig: BaseIconOptions = {
  iconAnchor: [20, 45],
  popupAnchor: [0, -45],
  iconSize: [40, 45],
};

const mapPinIconConfig: BaseIconOptions = {
  iconAnchor: [16, 37],
  popupAnchor: [0, -37],
  iconSize: [32, 37],
};

export const DELIVERY_POINTER_ICON = new Icon({
  iconUrl: ClientPin,
  ...mapPinIconConfig,
});

export const PLACE_POINTER_ICON = new Icon({
  iconUrl: PlacePin,
  ...mapPinIconConfig,
});

export const DELIVERYMAN_GOING_TO_STORE_ICON = new Icon({
  iconUrl: image.marker_indo_estabelecimento,
  ...dashboardIconConfig,
});

export const DELIVERYMAN_IN_DELIVERY_ICON = new Icon({
  iconUrl: image.marker_entregando,
  ...dashboardIconConfig,
});
